import React from "react";
import MenuBookIcon from "@material-ui/icons/MenuBook";
import MailOutlineIcon from "@material-ui/icons/MailOutline";
import SettingsIcon from "@material-ui/icons/Settings";
import { createMenuNode } from "./menu";
import { BaseMenuItem } from "./menu-item";

const menuBottom = [
  createMenuNode({
    name: "Settings",
    path: "/OwnerSettings",
    icon: <SettingsIcon />,
  }),
  createMenuNode({
    name: "Documentation",
    icon: <MenuBookIcon fontSize={"small"} />,
    link: "https://support.exirio.com/",
  }),
  createMenuNode({
    name: "Help & Feedback",
    icon: <MailOutlineIcon fontSize={"small"} />,
    link: "mailto:support@exirio.com?subject= Help & Feedback",
  }),
];

export function MenuBottom({ onClick }) {
  return (
    <>
      {menuBottom.map((item) => (
        <BaseMenuItem key={item.id} menu={item} onClick={onClick} />
      ))}
    </>
  );
}
